import { render, staticRenderFns } from "./FriendsList.vue?vue&type=template&id=6cc419c2"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"
import style0 from "./FriendsList.vue?vue&type=style&index=0&id=6cc419c2&prod&module=%24friends&lang=scss"




function injectStyles (context) {
  
  this["$friends"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports